import { useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import $ from 'jquery';
import axiosBaseURL from "./member/httpCommon.js";

export default function Booking() {
      // const [selectedDate, setselectedDate] = useState(null);

      const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const[hotelList, sethotelList] = useState([]);

const allhotelist = ()=> {    
      axiosBaseURL.get('/getbeapi').then((res)=> {
          sethotelList(res.data.p_data)
      }).catch((err) => {
          // console.log(err)
      })
  }

  useEffect(()=>{
    allhotelist();
    window.scrollTo(0, 0);
  },[]);

  const details = {
    name:'Raj',
    fsize:'40px',
    fweight: '600',
    fcolor: '#000'

  }


  const[hotel2, sethotel2] = useState('');
    const allhotels = (e) => {
    e.preventDefault()
    sethotel2(( $("#getBeCityHotel").val()))
    // setbrandid(e.target.value);
    
    console.log("getting Hotel Name "+ hotel2)
    };
  
    return (
      <>
      
<section className="booking-form-section wow fadeInDown" data-wow-duration="2s" id="booking-engine">
        <article className="container">
          <div className="enqiure-inner">
            <div className="row">

               <div className="custom-form-outer-div">
               <span>Checkin - Checkout Date</span>
               <DatePicker
               className='form-control'
      selectsRange={true}
      dateFormat="dd/MM/yyyy"
      minDate={new Date()}
      startDate={startDate}
      endDate={endDate}
      monthsShown={2}
      placeholderText='please select date'
      onChange={(update) => {
        setDateRange(update);
      }}
      isClearable={true}
    />
               {/* <DatePicker
      closeOnScroll={true}
      selected={selectedDate}
      onChange={date => setselectedDate(date)}
    /> */}
                 
               </div>
               
            
               <div className="custom-form-outer-div">
                <span>Room</span>
                <select className="form-select" name="selectedFruit" defaultValue="orange" aria-label="Default select example">
                   <option value="1">2 Room</option>
                   <option value="2">3 Room</option>
                   <option value="3">4 Room</option>
                </select>
             </div> 
             <div className="custom-form-outer-div d-none">
                <span>Select {details.name}</span>
             <select onChange={allhotels} className="form-control form-select" name="getBeCityHotel" id="getBeCityHotel">
                {
                    hotelList.map((val) =>
                    <option key={val.synxis_id} value={val.synxis_id}>  { val.hotel_name}  </option>
                    )
                }
                    {
                    hotelList.map((val) =>
                    <option key={val.synxis_id} value={val.synxis_id}>   <b>{ val.city_name}</b> </option>
                    )
                }
             </select>

             </div>
               <div className="custom-form-outer-div">
                  <span>Adults</span>
                  <select className="form-select" aria-label="Default select example">
                     <option selected>1 Adults</option>
                     <option value="1">2 Adults</option>
                     <option value="2">3 Adults</option>
                     <option value="3">4 Adults</option>
                  </select>
               </div>
              
               <div className="custom-form-outer-div btn-div">
                  <span>&nbsp;</span>
                  <button type="submit" className="btn btn-primary w-100">Check Availability</button>
               </div>
            </div>
         </div>
        </article>
    </section>
      </>
    );
  }
  

